import styled from 'styled-components';
import { ThemeColours } from '../../../styles/ThemeColours';
import {
  Breakpoint,
  FontWeight,
  FONT_STACK,
  RESET_IOS_INPUT_STYLE,
  STANDARD_TRANSITION,
} from '../../../styles/constants';
import { onMobile } from '../../../styles/onMobile';
import { IconCross } from '../../icons/IconCross';
import { IconSearch } from '../../icons/IconSearch';

export const SearchBarView = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  height: 48px;

  ${onMobile} {
    flex-grow: 1;
    max-width: none;
    width: unset;
  }
`;

export const Bar = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  height: 48px;
  position: relative;
  width: auto;
`;

export const Input = styled.input<{ inlineFocus?: boolean }>`
  ${STANDARD_TRANSITION};
  ${RESET_IOS_INPUT_STYLE};
  background-color: ${ThemeColours.mono100};
  border: solid 1px ${ThemeColours.mono200};
  border-radius: 24px;
  box-sizing: border-box;
  color: ${ThemeColours.black};
  ${FONT_STACK}
  font-size: 16px;
  font-weight: ${FontWeight.SEMI_BOLD};
  height: 100%;
  overflow: hidden;
  padding: 0 48px 0 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;

  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${ThemeColours.mono600};
  }

  &:hover {
    box-shadow: 0 1px 2px 0 rgba(92, 119, 131, 0.1);
  }

  &:focus {
    background-color: ${ThemeColours.white};
    outline: none;
  }

  &:not(:placeholder-shown) {
    padding: 0 80px 0 16px;
  }

  ${onMobile} {
    padding: 0 16px 0 16px;

    &:not(:placeholder-shown) {
      padding: 0 32px 0 16px;
    }
  }
`;

export const SearchIconBackground = styled.div<{ altTheme: boolean }>`
  align-items: center;
  background-color: ${props => (props.altTheme ? ThemeColours.accent300 : ThemeColours.black)};
  border-radius: 32px;
  cursor: pointer;
  display: flex;
  fill: currentColor;
  height: 32px;
  position: absolute;
  right: 8px;
  top: 8px;
  width: 32px;
`;

export const SearchIcon = styled(IconSearch)`
  color: ${ThemeColours.white};
  height: 16px;
  margin: 0 auto;
  width: 16px;
`;

export const CompactSearchIconBackground = styled.div`
  align-items: center;
  border: 1px solid ${ThemeColours.mono100};
  border-radius: 42px;
  cursor: pointer;
  display: flex;
  fill: currentColor;
  height: 42px;
  margin-right: 12px;
  width: 42px;
`;

export const CompactSearchIcon = styled(IconSearch)`
  color: ${ThemeColours.black};
  height: 24px;
  margin: 0 auto;
  width: 24px;
`;

export const CrossIcon = styled(IconCross)`
  color: ${ThemeColours.black};
  cursor: pointer;
  height: 24px;
  position: absolute;
  right: 12px;
  top: 12px;
  width: 24px;

  ${Breakpoint.SMALL} {
    right: 56px;
  }
`;
